export const SET_FILTERS_CLIENTS = 'SET_FILTERS_CLIENTS';

export const setFiltersClients = ({ text, identifier }) => ({
    type: SET_FILTERS_CLIENTS,
    payload: {
        text,
        identifier
    }
});
